'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTypingTimeoutIdForAgentInThread = undefined;

var _reduxActions = require('redux-actions');

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

var addTypingTimeoutIdForAgentInThread = exports.addTypingTimeoutIdForAgentInThread = (0, _reduxActions.createAction)(_typingIndicatorActionTypes.ADD_AGENT_TYPING_TIMEOUT_ID, function (threadId, agentId, timeoutId) {
  return {
    threadId: threadId,
    agentId: agentId,
    timeoutId: timeoutId
  };
});